import { useEffect, useState } from "react";
import { Warning } from "@phosphor-icons/react";

export default function LostDialog({ open, onClose, onConfirm }) {
  const [reason, setReason] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => { if (open) setReason(""); }, [open]);
  if (!open) return null;

  const handleConfirm = async () => {
    if (!reason.trim()) return;
    setSubmitting(true);
    try { await onConfirm(reason.trim()); } finally { setSubmitting(false); }
  };

  return (
    <div
      className="fixed inset-0 z-[60] flex items-end md:items-center justify-center bg-slate-900/40 backdrop-blur-sm"
      onClick={onClose}
      data-testid="lost-dialog"
    >
      <div
        className="w-full md:max-w-md bg-white rounded-t-3xl md:rounded-3xl p-6 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center gap-3 mb-2">
          <div className="w-10 h-10 rounded-full bg-[color:var(--cf-danger-soft)] flex items-center justify-center">
            <Warning size={20} color="var(--cf-danger)" weight="fill" />
          </div>
          <h3 className="font-display text-xl font-extrabold text-slate-900">Marquer comme perdu</h3>
        </div>
        <p className="text-sm text-slate-500 mt-1">Indique le motif. Cette action est documentée et réversible.</p>

        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Ex. Refus banque, apport insuffisant, client désisté…"
          className="cf-input mt-4 h-24 resize-none"
          data-testid="lost-reason-input"
        />

        <div className="flex gap-2 mt-4">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-3 rounded-xl bg-slate-100 text-slate-700 text-sm font-semibold hover:bg-slate-200"
            data-testid="lost-cancel"
          >
            Annuler
          </button>
          <button
            onClick={handleConfirm}
            disabled={!reason.trim() || submitting}
            className="flex-1 px-4 py-3 rounded-xl bg-[color:var(--cf-danger)] text-white text-sm font-bold hover:bg-[color:var(--cf-danger)] disabled:opacity-40 shadow-[0_4px_12px_rgba(239,68,68,0.3)]"
            data-testid="lost-confirm"
          >
            {submitting ? "…" : "Confirmer"}
          </button>
        </div>
      </div>
    </div>
  );
}
